export const FooterEvent = {
  FooterMenuClick: 'footer_menu_click',
} as const;

export interface FooterEventDataType {
  [FooterEvent.FooterMenuClick]: {
    category: string;
    button_text: string;
  };
}
